/*eslint-disable */
import React, { FC, useState, useEffect } from 'react';
import { Switch, Route, Router, Redirect } from 'Utils/router';
import { useSelector, useDispatch } from 'react-redux';
import { PrivateRoutes } from './index';

import Wrapper from 'HOC/Wrapper';
import { Details, Explore, List } from 'Pages/Leads';
import { ContentPerformance, EduVsNetwork } from 'Pages/Analytics';
import Logout from 'Pages/Logout';

import Nav from 'Containers/Headers/Nav';
import Announcements from 'Containers/Announcements';
import Toast from 'Containers/Toast';
import Modal from 'Containers/Modal';
import Center from 'Components/Helpers/Center';
import { Loading } from 'Components/Loading';
import PageNotFound from 'Components/PageNotFound';
import { setFullAccess } from 'Containers/FullAccess/actions/fullaccess.actions';

import { version as app_version } from '../../package.json';

interface Props {
  apolloData?: object;
}

/**
 * Date for app is "last week"
 * TODO: this should be in a store once we allow changing date via drop down...
 */
/*************
let beforeOneWeek = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000),
  day = beforeOneWeek.getDay(),
  diffToMonday = beforeOneWeek.getDate() - day + (day === 0 ? -6 : 1),
  lastMonday = new Date(beforeOneWeek.setDate(diffToMonday)),
  lastSunday = new Date(beforeOneWeek.setDate(diffToMonday + 6)),
  startDate = lastMonday.toISOString().split("T")[0],
  endDate = lastSunday.toISOString().split("T")[0];
************/
//TODO while testing we hard code these to a week with data...
const startDate = '2019-10-14',
  endDate = '2019-10-20';
/*
    There is an issue with wrapping routes like this <Wrapper><route... /></Wrapper>
    Routes are not being fired off.  If you need the <Wrapper> use it in the render method of the route.
    This will return the element that the route expects, instead of the function from the <Wrappe> component.
    Ie.
    <Route
      exact
      path="/leads/detail/:audienceKey"
      render={props => (
        <Wrapper>
          <AudienceDetails
            audience_key={props.match.params.audienceKey}
          />
        </Wrapper>
      )}
    />
  
    See here for a further explanation.  Last answer

    https://stackoverflow.com/questions/45877620/wrap-a-react-route-render-function-in-a-hoc
  */

/*
  
        NOTE:  The wrapper component now has a prop
        By default, you don't have to do anything.  But if you need the entire screen, like
        leadsExplore route does, you can then pass the boolean in as false.  This will tell
        the wrapper not to add a class that fixes the width.
        Ie.
        <Wrapper useFixedWidth={false}>
          <LeadsExplore startDate={startDate} endDate={endDate} />
        </Wrapper>
  
  */
const Routes: FC<Props> = () => {
  // store modules //
  const [moduleAccess, setModuleAccess] = useState<any>({});
  const dispatch = useDispatch();
  const fullAccess = useSelector((store: any) => store.fullAccess);
  const [isSuperUser, setIsSuperUser] = useState<boolean>(true);
  useEffect(() => {
    if (window.location.href.indexOf('fullAccess=1') != -1)
      dispatch(setFullAccess(true));
    else dispatch(setFullAccess(false));
  }, []);

  const redirectOutOfAAP = () => {
    if (isSuperUser) return false;
    if (Object.keys(moduleAccess).length === 0) return null;
    let redirect = true;
    for (const [module, value] of Object.entries(moduleAccess)) {
      if (value) {
        redirect = false;
        break;
      }
    }
    return redirect;
  };

  // redirect to correct page baed on modules //
  const redirectToPage = () => {
    // if no AAP modules are found, redirect out of AAP //
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    if (redirectOutOfAAP())
      window.location.replace(`${baseUrl}cms/Utilities/redirectAnalytics`);

    if (moduleAccess.AAP_INQUIRY_EXPLORE) return '/inquiries/explore';
    if (moduleAccess.AAP_INQUIRY_LISTS) return '/inquiries/lists';
    if (moduleAccess.AAP_ANALYTICS_CONTENT_PERFORMANCE)
      return '/analytics/content-performance';
    if (moduleAccess.AAP_ANALYTICS_MY_EDU_VS_NETWORK)
      return '/analytics/edu-vs-network';
    return '/';
  };

  const redirectToAnalytics = () => {
    if (moduleAccess.AAP_ANALYTICS_CONTENT_PERFORMANCE)
      return '/analytics/content-performance';
    if (moduleAccess.AAP_ANALYTICS_MY_EDU_VS_NETWORK)
      return '/analytics/edu-vs-network';
    return '/';
  };

  return (
    <Router>
      <div style={{ opacity: Object.keys(moduleAccess).length > 0 ? 0 : 1 }}>
        <Center>
          <Loading />
        </Center>
      </div>
      <div style={{ opacity: Object.keys(moduleAccess).length > 0 ? 1 : 0 }}>
        <PrivateRoutes>
          <Nav
            setModuleAccess={setModuleAccess}
            setIsSuperUser={setIsSuperUser}
          />
          <div>
            <span
              style={{
                position: 'fixed',
                bottom: '20px',
                right: '5px',
                color: '#a7a7a7',
              }}
            >
              v{app_version}
            </span>
            <Modal />
            <Toast />

            <Announcements />

            <Switch>
              {/* INQUIRIES */}
              <Redirect exact from="/" to={redirectToPage()} />
              <Route
                path="/inquiries/explore"
                render={() => (
                  <Wrapper style={{ padding: 0 }} useFixedWidth={false}>
                    <Explore startDate={startDate} endDate={endDate} />
                  </Wrapper>
                )}
              >
                {!moduleAccess.AAP_INQUIRY_EXPLORE && (
                  <Wrapper>
                    <PageNotFound text="You are not authorized to view this page" />
                    {!fullAccess && Object.keys(moduleAccess).length !== 0 && (
                      <Redirect to="/" />
                    )}
                  </Wrapper>
                )}
              </Route>
              <Route
                exact
                path="/inquiries/detail/:audienceKey/view/:viewName"
                render={props =>
                  moduleAccess.AAP_INQUIRY_EXPLORE ? (
                    <Wrapper>
                      <Details
                        audience_key={props.match.params.audienceKey}
                        view={props.match.params.viewName}
                      />
                    </Wrapper>
                  ) : (
                    <Wrapper>
                      <PageNotFound text="You are not authorized to view this page" />
                    </Wrapper>
                  )
                }
              />
              <Route
                exact
                path="/inquiries/lists/:listId"
                render={props => (
                  <Wrapper style={{ padding: 0 }} useFixedWidth={false}>
                    <Explore listId={props.match.params.listId} />
                  </Wrapper>
                )}
              >
                {!moduleAccess.AAP_INQUIRY_LISTS && (
                  <Wrapper>
                    <PageNotFound text="You are not authorized to view this page" />
                  </Wrapper>
                )}
              </Route>
              <Route
                exact
                path="/logout"
                render={() => (
                  <Wrapper>
                    <Logout />
                  </Wrapper>
                )}
              />
              <Route
                path="/inquiries/lists"
                render={() => (
                  <Wrapper>
                    <List />
                  </Wrapper>
                )}
              >
                {!moduleAccess.AAP_INQUIRY_LISTS && (
                  <Wrapper>
                    <PageNotFound text="You are not authorized to view this page" />
                    {!fullAccess && Object.keys(moduleAccess).length !== 0 && (
                      <Redirect to="/" />
                    )}
                  </Wrapper>
                )}
              </Route>

              {/* ANALYTICS */}
              <Redirect exact from="/analytics" to={redirectToAnalytics()} />
              <Route
                exact
                path="/analytics/content-performance"
                render={() => (
                  <Wrapper>
                    <ContentPerformance moduleAccess={moduleAccess} />
                  </Wrapper>
                )}
              >
                {!moduleAccess.AAP_ANALYTICS_CONTENT_PERFORMANCE && (
                  <Wrapper>
                    <PageNotFound text="You are not authorized to view this page" />
                    {!fullAccess && Object.keys(moduleAccess).length !== 0 && (
                      <Redirect to="/" />
                    )}
                  </Wrapper>
                )}
              </Route>
              <Route
                exact
                path="/analytics/edu-vs-network"
                render={() => (
                  <Wrapper>
                    <EduVsNetwork />
                  </Wrapper>
                )}
              >
                {!moduleAccess.AAP_ANALYTICS_MY_EDU_VS_NETWORK && (
                  <Wrapper>
                    <PageNotFound text="You are not authorized to view this page" />
                    {!fullAccess && Object.keys(moduleAccess).length !== 0 && (
                      <Redirect to="/" />
                    )}
                  </Wrapper>
                )}
              </Route>
              <Route path="*">
                <Wrapper>
                  <PageNotFound />
                </Wrapper>
              </Route>
            </Switch>
          </div>
        </PrivateRoutes>
      </div>
    </Router>
  );
};

export default Routes;
try {
    // @ts-ignore
    routes.displayName = "routes";
    // @ts-ignore
    routes.__docgenInfo = { "description": "", "displayName": "routes", "props": { "apolloData": { "defaultValue": null, "description": "", "name": "apolloData", "required": false, "type": { "name": "object" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/routes/routes.tsx#routes"] = { docgenInfo: routes.__docgenInfo, name: "routes", path: "src/routes/routes.tsx#routes" };
}
catch (__react_docgen_typescript_loader_error) { }